export function log(message: string) {
  console.debug(`%c ${message}`, 'color: #907ff5');
}
